import { render, staticRenderFns } from "./donation-complete.vue?vue&type=template&id=cb60ac82&scoped=true"
import script from "./donation-complete.vue?vue&type=script&setup=true&lang=js"
export * from "./donation-complete.vue?vue&type=script&setup=true&lang=js"
import style0 from "./donation-complete.vue?vue&type=style&index=0&id=cb60ac82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb60ac82",
  null
  
)

export default component.exports